import React from 'react';
import classNames from 'classnames';

import { CoreLink, Node } from '@uncinc/react-drupal-core';

const ArticlesPromoted = ({ entities, linkUri, linkTitle }) => {
  return (
    <div className="ArticlesPromoted">
      <div className="row">
        <div className="col-12 col-md-6">
          {entities.slice(0, 1).map((entity, index) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const classes = classNames('ArticlesPromoted__highlighted');

            return (
              <div key={`${uuid}:${langcode}`} className={classes}>
                <Node
                  id={id}
                  key={`${uuid}:${langcode}`}
                  entity={entity}
                  viewMode="highlighted"
                />
              </div>
            );
          })}
        </div>
        <div className="col-12 col-md-6">
          {entities.slice(1).map((entity, index) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const classes = classNames('ArticlesPromoted__row');

            return (
              <div key={`${uuid}:${langcode}`} className={classes}>
                <Node
                  id={id}
                  key={`${uuid}:${langcode}`}
                  entity={entity}
                  viewMode="small"
                />
              </div>
            );
          })}
          <div className="ArticlesPromoted__link_wrapper">
            { linkUri && linkTitle && (
              <div className="ArticlesPromoted__link">
                <CoreLink to={linkUri} className="icon-after icon-chevron-right">
                  {linkTitle}
                </CoreLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlesPromoted;
